import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { pageSizes, PaginationPageSize } from '@markant-platform/shared/table/model';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'markant-platform-pagination-footer',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoModule],
  templateUrl: './pagination-footer.component.html',
  styleUrls: ['./pagination-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationFooterComponent {
  selectLabelKey = input<string>('common.pageSelection');
  goToPageKey = input<string>('common.goToPage');
  totalCount = input<number>();
  pageSize = input<PaginationPageSize>(25);
  pageIndex = input<number>(1);

  indexChanged = output<CustomEventInit<number>>();
  pageSizeChanged = output<CustomEventInit<PaginationPageSize>>();

  protected readonly pageSizes = signal(pageSizes);

  onPageSizeChange(event: CustomEventInit<number>): void {
    if (event?.detail) {
      this.pageSizeChanged.emit(event as CustomEventInit<PaginationPageSize>);
    }
  }
}
